import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as fromPcpLiveAuth from './auth.reducer';
import { StoreModule } from '@ngrx/store';

@NgModule({
    imports: [CommonModule, StoreModule.forFeature(fromPcpLiveAuth.authFeatureKey, fromPcpLiveAuth.reducer)],
})
export class LiveLessonSharedDataAccessAuthModule {}
